import * as React from 'react';
import TextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import { FieldProps, getIn } from 'formik';
import InputMask, { InputState, MaskOptions } from 'react-input-mask';

export interface FormikMaskedInputProps
    extends FieldProps,
        Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {
    mask: string | [];
    beforeMaskedValueChange?: (
        newState: InputState,
        oldState: InputState,
        userInput: string,
        maskOptions: MaskOptions
    ) => InputState;
}

export function fieldToTextField({
    disabled,
    field,
    form: { touched, errors },
    ...props
}: FormikMaskedInputProps): MuiTextFieldProps {
    const fieldError = getIn(errors, field.name);
    const showError = getIn(touched, field.name) && !!fieldError;

    return {
        ...props,
        ...field,
        error: showError,
        helperText: showError ? fieldError : props.helperText,
        variant: props.variant,
    };
}

export default function FormikMaskedInput({ children, ...props }: FormikMaskedInputProps) {
    return (
        <InputMask
            mask={props.mask}
            value={props.field.value}
            beforeMaskedValueChange={props.beforeMaskedValueChange}
            disabled={false}
            maskChar="a"
            onBlur={props.field.onBlur}
            onChange={props.field.onChange}
        >
            <TextField {...fieldToTextField(props)}>{children}</TextField>
        </InputMask>
    );
}
